import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Home',
  },
  {
    displayName: 'Dashboard',
    iconName: 'layout-dashboard',
    route: '/dashboard',
  },
  {
    navCap: 'Ui Components',
  },
  {
    displayName: 'Badge',
    iconName: 'rosette',
    route: '/ui-components/badge',
  },
  {
    displayName: 'Chips',
    iconName: 'poker-chip',
    route: '/ui-components/chips',
  },
  {
    displayName: 'Lists',
    iconName: 'list',
    route: '/ui-components/lists',
  },
  {
    displayName: 'Menu',
    iconName: 'layout-navbar-expand',
    route: '/ui-components/menu',
  },
  {
    displayName: 'Tooltips',
    iconName: 'tooltip',
    route: '/ui-components/tooltips',
  },
  {
    navCap: 'Auth',
  },
  {
    displayName: 'Login',
    iconName: 'lock',
    route: '/authentication/login',
  },
  {
    displayName: 'Register',
    iconName: 'user-plus',
    route: '/authentication/register',
  },
  {
    navCap: 'Consoles',
  },
  {
    displayName: 'Ops Console',
    iconName: 'dashboard',
    route: '/workspace/ops-console',
    requiredVisibility: 'internal',
  },
  {
    displayName: 'Sales Console',
    iconName: 'chart-bar',
    route: '/workspace/sales-console',
    requiredVisibility: 'internal',
  },
  {
    displayName: 'Customers',
    iconName: 'users',
    route: '/workspace/sales-console/customers',
    requiredVisibility: 'internal',
  },
  {
    displayName: 'Queries Report',
    iconName: 'chart-pie',
    route: '/workspace/sales-console/reports',
    requiredVisibility: 'internal',
  },
  {
    displayName: 'Vendor Console',
    iconName: 'user-circle',
    route: '/workspace/vendor',
  },
  {
    displayName: 'Customer Console',
    iconName: 'briefcase',
    route: '/workspace/customer',
  },
  {
    displayName: 'Internal Team Console',
    iconName: 'building-skyscraper',
    route: '/workspace/internal-team',
  },
  {
    navCap: 'Extra',
  },
  {
    displayName: 'Icons',
    iconName: 'mood-smile',
    route: '/extra/icons',
  },
  {
    displayName: 'Sample Page',
    iconName: 'aperture',
    route: '/extra/sample-page',
  },
];
